export default __webpack_public_path__ + "static/media/HeroBannerModel.1b4f5cd5.png";